
import { START_TIMER, CLOSE_TIMER, DECREMENT_TIMER } from './actionTypes';

export const startTimer = () => {
    return {
        type: START_TIMER,
    }
}

export const closeTimer = () => {
    return {
        type: CLOSE_TIMER,
    }
}

export const decrementTimer = (time) => {
    return {
        type: DECREMENT_TIMER,
        payload: time,
    }
}